import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
    code: 'Conversation.CallList.ViewOption'
})
export class ConversationCallListViewOption {
    @GenericLookup({
        code: 'Conversation.CallList.ViewOption.Standard'
    })
    static standard: number;
}
